module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "false",
      "value": _vm.value,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "clearable": _vm.clearable,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "prefix-icon": _vm.iconLeft,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "keydown": function($event) {
        return _vm.$emit('keydown', $event)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1e03450"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputText.vue
// module id = 1534
// module chunks = 45